import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { EmitBo, SessionFormSaveBO } from '../consultation-services.modal';
import { ConsultationServices } from '../consultation-services.service';
import { takeUntil } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { NgxExtendedPdfViewerService } from 'ngx-extended-pdf-viewer';

@Component({
  selector: 'app-cfss-pdf-view',
  templateUrl: './cfss-pdf-view.component.html',
  styleUrls: ['./cfss-pdf-view.component.scss']
})
export class CfssPdfViewComponent implements OnInit {
  private onDestroy$: Subject<void> = new Subject<void>();
  @Input() getValues = new EmitBo;
  @Output() EventEmit = new EventEmitter<EmitBo>();
  pdfBase64: any=null;
  saveFormBo: SessionFormSaveBO = new SessionFormSaveBO();
  constructor(public CSService: ConsultationServices, private toastrService: ToastrService, private ngxService: NgxExtendedPdfViewerService,) { }

  ngOnInit(): void {
    if (this.getValues.isUpdateForm) {
      this.getSessionPDFForm();
    } else {
      this.getForm();
    }
  }

  closeViewPdf() {
    this.addNewItem(this.getValues);
  }
  getForm() {
    let blob = this.base64ToBlob(this.getValues.byteArray)
    this.pdfBase64 = URL.createObjectURL(blob);
  }
  addNewItem(value: EmitBo) {
    value.EngagementId = "00000000-0000-0000-0000-000000000000";
    value.FormTemplateId = "00000000-0000-0000-0000-000000000000";
    value.isChild = false;
    value.byteArray = null
    this.EventEmit.emit(value);
  }

  base64ToBlob(base64) {
    const byteCharacters = atob(base64);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    return new Blob([byteArray], { type: "application/pdf" });
  }
  SaveOrUpdateSessionPDFForm(){
    if (this.getValues.isUpdateForm) {
      this.UpdateSessionPDFForm();
    } else {
      this.saveSessionPDFForm();
    }
  }
  // ...............................saveSessionPDFForm.................................
  async saveSessionPDFForm() {
    const blob = await this.ngxService.getCurrentDocumentAsBlob();
   
    let fileName = "Sessiontform.pdf";
    const file = new File([blob], fileName);
    let Formdata = new FormData();
    Formdata.append("engagementId", this.getValues.EngagementId);
    Formdata.append("dynamicFormTemplateId", (this.getValues.FormTemplateId == null || this.getValues.FormTemplateId == undefined || this.getValues.FormTemplateId == "") ? "00000000-0000-0000-0000-000000000000" : this.getValues.FormTemplateId);
    Formdata.append("file", file);
    this.CSService
      .SaveSessionFormTemplate(Formdata)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data) => {
          this.toastrService.success("Saved successfully!");
          this.addNewItem(this.getValues);
          setTimeout(() => {
            this.toastrService.clear();
          }, 8000);
        },
        (err: HttpErrorResponse) => {
          this.toastrService.error(err.error, " Error");
          setTimeout(() => {
            this.toastrService.clear();
          }, 2000);
        }
      );
  }
 // ...............................UpdateSessionPDFForm.................................
 async UpdateSessionPDFForm() {
  const blob = await this.ngxService.getCurrentDocumentAsBlob();
  let fileName = "Sessiontform.pdf";
  
  const file = new File([blob], fileName);
  let Formdata = new FormData();
  Formdata.append("engagementId", this.getValues.EngagementId);
  Formdata.append("sessionFormId", (this.getValues.sessionFormId == null || this.getValues.sessionFormId == undefined || this.getValues.sessionFormId == "") ? "00000000-0000-0000-0000-000000000000" : this.getValues.sessionFormId);
  Formdata.append("file", file);
 
  this.CSService
    .UpdateSessionFormTemplate(Formdata)
    .pipe(takeUntil(this.onDestroy$))
    .subscribe(
      (data) => {
        this.toastrService.success("Updated successfully!");
        this.addNewItem(this.getValues);
        setTimeout(() => {
          this.toastrService.clear();
        }, 8000);
      },
      (err: HttpErrorResponse) => {
        this.toastrService.error(err.error, " Error");
        setTimeout(() => {
          this.toastrService.clear();
        }, 2000);
      }
    );
}
  getSessionPDFForm() {
    let payload = {
      engementId: this.getValues.EngagementId,
      templateId: this.getValues.FormTemplateId,
      sessionFormId: this.getValues.sessionFormId
    }
    this.CSService
      .GenerateDynamicSessionForm(payload)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data) => {

         
          var blob = this.b64toBlob(data.formBytearray);
          this.pdfBase64 = window.URL.createObjectURL(blob);
         
        },
        (err: HttpErrorResponse) => {
          this.toastrService.error(err.error, " Error");
          setTimeout(() => {
            this.toastrService.clear();
          }, 2000);
        }
      );
  }
  b64toBlob(b64Data) {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += 512) {
      const slice = byteCharacters.slice(offset, offset + 512);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    const blob = new Blob(byteArrays, { type: "application/pdf" });
    return blob;
  }
}
